import { decamelizeKeys } from 'humps'

import requestCaller from '@/utils/request'

class BaseApi {
  constructor(uri, caller = requestCaller) {
    this.uri = uri
    this.request = caller
  }

  create = (data) => {
    const dataToBeSent = decamelizeKeys(data)

    return this.request({
      method: 'POST',
      path: this.uri + '/create',
      data: dataToBeSent,
    })
  }

  fetchList = (data) => {
    const dataToBeSent = decamelizeKeys(data)

    return this.request({
      method: 'GET',
      path: this.uri + '/list',
      data: dataToBeSent,
    })
  }
}

export default BaseApi
